import { render, staticRenderFns } from "./OrganizationCard.vue?vue&type=template&id=59061c4a&scoped=true&"
import script from "./OrganizationCard.vue?vue&type=script&lang=js&"
export * from "./OrganizationCard.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationCard.vue?vue&type=style&index=0&id=59061c4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59061c4a",
  null
  
)

export default component.exports